export default __webpack_public_path__ + "static/media/circle-checked.ab380415.svg";